import { ShieldCheck, Rocket, Eye, PiggyBank } from "lucide-react";

const items = [
  {
    icon: ShieldCheck,
    title: "Satisfaction Guarantee",
    desc: "GEES leverages 25+ years of energy industry experience across global projects.",
  },
  {
    icon: Rocket,
    title: "Quick Wins",
    desc: "Lucrative projects already in pipeline across EPC, Construction and BOOT.",
  },
  {
    icon: Eye,
    title: "Transparent",
    desc: "We always keep our clients and partners fully informed throughout delivery.",
  },
  {
    icon: PiggyBank,
    title: "Cost Effective",
    desc: "Services up to 50% less expensive compared with in‑house resourcing.",
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why" data-testid="why-section" className="py-20 lg:py-28 bg-white">
      <div className="container-wide">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-primary">
            Our Benefits
          </p>
          <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground">
            Why choose GEES
          </h2>
          <p className="mt-5 text-base lg:text-lg text-muted-foreground leading-relaxed">
            We assess, evaluate and provide customised <span className="text-foreground font-semibold">one‑stop solutions for energy transition and emissions mitigation projects</span> to achieve global net carbon zero targets.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((it) => (
            <div
              key={it.title}
              data-testid={`why-card-${it.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="hover-lift rounded-2xl border border-border bg-secondary/40 p-6"
            >
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground">
                <it.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-5 font-display font-semibold text-lg text-foreground">
                {it.title}
              </h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                {it.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
